import { createSelector } from "reselect"
import { chain } from "lodash"
import { getIsInvalidBetaInstrumentReason } from "modules/portfolio-root/selectors/beta-instrument"
import { computeData, getAllCategoryItems } from "modules/analyze-composition/selectors/data"
import { getBeta } from "modules/analyze-composition/selectors/beta"
import { computeSelected, computeSelectedValue, getLastContributor as getLastContributorHelper } from "helpers/contributors"

const getSelectedDate = (_, props) => props.selectedDate
const getSelectedRaw = state => state.modules.analyzeBetaDetails.selected

const getContributorData = createSelector(
  [getAllCategoryItems, getBeta],
  (categoryItems, beta) => computeData(categoryItems, beta),
)

export const getSelected = createSelector(
  [getSelectedRaw, getAllCategoryItems],
  computeSelected,
)

export const getDetails = createSelector(
  [getContributorData, getSelectedDate, getAllCategoryItems, getIsInvalidBetaInstrumentReason],
  (data, date, categoryItems, invalidBetaInstrumentReason) => {
    const lastContributor = getLastContributorHelper(data, date) || {}

    return chain(categoryItems)
      .map(item => {
        const isDynamicBeta = item.id === "custom" && item.category === "beta"

        return {
          label: item.label,
          id: item.id,
          value: isDynamicBeta && invalidBetaInstrumentReason ? "-" : lastContributor[item.id],
          color: item.color,
          category: item.category,
          field: item.field,
          tooltip: item.tooltip,
          adjustedReason: isDynamicBeta && invalidBetaInstrumentReason ? invalidBetaInstrumentReason : null,
        }
      })
      .filter(item => item.value)
      .value()
  },
)

export const getSelectedValue = createSelector(
  [getDetails, getSelected],
  computeSelectedValue,
)
